// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgInterests: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M1.601 11.204a.75.75 0 0 1-.656-1.114L5.4 2.072a.75.75 0 0 1 1.311 0l4.455 8.018a.75.75 0 0 1-.656 1.114zm4.455 11.458c-1.26 0-2.34-.448-3.237-1.346-.898-.897-1.347-1.976-1.347-3.237 0-1.26.449-2.34 1.347-3.237.897-.898 1.976-1.346 3.237-1.346 1.26 0 2.339.448 3.237 1.346.897.898 1.346 1.977 1.346 3.237s-.449 2.34-1.346 3.237c-.898.898-1.977 1.346-3.237 1.346m7.875 0a1 1 0 0 1-1-1v-7.166a1 1 0 0 1 1-1h7.166a1 1 0 0 1 1 1v7.166a1 1 0 0 1-1 1z" />
        <path
          fillRule="evenodd"
          d="M23.263 4.698c0-2.026-1.376-3.496-3.271-3.496-1.016 0-1.563.37-2.442 1.208-.88-.84-1.427-1.21-2.443-1.21-1.896 0-3.272 1.47-3.272 3.495 0 .85.309 1.653.875 2.288l4.587 4.123a.39.39 0 0 0 .506 0l4.39-3.917.095-.1.095-.099c.57-.635.88-1.44.88-2.292"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgInterests);
export default Memo;
